export type ModalComponent = {
    isOpen: boolean;
    previouslyFocused: HTMLElement | null;
    $nextTick(callback: () => void): void;
    $watch(property: string, callback: (value: boolean) => void): void;
    $refs: Record<string, HTMLElement>;
    init(): void;
    destroy(): void;
    openModal(index?: number): void;
    closeModal(): void;
    restoreFocus(): void;
};

export default function modal(): ModalComponent {
    return {
        isOpen: false,
        previouslyFocused: null,

        init() {
            this.$watch('isOpen', (value: boolean) => {
                document.body.style.overflow = value ? 'hidden' : '';
            });
        },

        destroy() {
            document.body.style.overflow = '';
        },

        openModal() {
            this.previouslyFocused =
                document.activeElement instanceof HTMLElement ? document.activeElement : null;
            this.isOpen = true;

            this.$nextTick(() => {
                this.$refs.closeButton?.focus();
            });
        },

        closeModal() {
            if (!this.isOpen) {
                return;
            }

            this.isOpen = false;
            this.restoreFocus();
        },

        restoreFocus() {
            this.$nextTick(() => {
                if (this.previouslyFocused) {
                    this.previouslyFocused.focus();
                    this.previouslyFocused = null;
                    return;
                }

                this.$refs.triggerButton?.focus();
            });
        },
    };
}
